import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';
import CaseUtil from '@common/lib/caseUtil';

function paymentFormatter({ action, orderParams }) {
  const orderParamsObj = orderParams
    ? CaseUtil.toCase('camelCase', orderParams) : undefined;
  const gtmData = JSON.parse(sessionStorage.getItem('gtm_data'));
  sessionStorage.removeItem('gtm_data');
  return getGTMEventData(EVENT_NAMES.PAYMENT, action, {
    paymentId: orderParamsObj?.razorpayPaymentId,
    orderId: orderParamsObj?.razorpayOrderId,
    amount: gtmData ? gtmData.amount / 100 : null,
    mode: gtmData?.mode,
  });
}

export default paymentFormatter;
